import {useCallback, KeyboardEvent} from 'react';

/**
 * Execute callback when `Enter` is pressed
 * @param cb Callback
 * @example 
   const doThingOnEnter = useCallback(() => {...}, []);
   const handleInputEnterKey = useHandleInputEnterKey(doThingOnEnter);
   return (
     <Input onKeyDown={handleInputEnterKey} />
   )
 */
export const useHandleInputEnterKey = (
	cb: (event: KeyboardEvent<HTMLInputElement>) => void,
) => {
	const handleInputEnterKey = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement>) => {
			if (event.key !== 'Enter') return;
			cb(event);
		},
		[cb],
	);
	return handleInputEnterKey;
};

export default useHandleInputEnterKey;
